export const IMG = {
  hero: "/generated/hero.png",
  pairs: [
    { slug: "living-room", label: "Living room" },
    { slug: "kitchen",     label: "Kitchen" },
    { slug: "exterior",    label: "Exterior" },
    { slug: "bedroom",     label: "Bedroom" },
    { slug: "bathroom",    label: "Bathroom" },
    { slug: "dining",      label: "Dining room" },
  ],
};

export const LOGO = {
  full: "https://customer-assets.emergentagent.com/job_04be8e34-a2b4-44e2-ab4e-58e9f67fb2dc/artifacts/3mtm3zkh_Pp.jpg",
  markLight: "https://customer-assets.emergentagent.com/job_04be8e34-a2b4-44e2-ab4e-58e9f67fb2dc/artifacts/qx3lo0wn_PNG-02.webp",
  markDark: "https://customer-assets.emergentagent.com/job_04be8e34-a2b4-44e2-ab4e-58e9f67fb2dc/artifacts/a8vj2c0x_PNG-01.webp",
};
